/* unplugin-vue-components disabled */import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-31c9e56c"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 开启后将对白名单以外的IP区域进行游戏登录限制 ");
const _hoisted_2 = {
  key: 0,
  class: "default-box marginB20"
};
const _hoisted_3 = {
  class: "ip"
};
const _hoisted_4 = {
  class: "area"
};
import USwitch from '@ultra/share/components/USwitch/index.vue';
import { apiUsdkGetTestAccountList, apiUsdkCreateTestAccount } from '@/api/usdk';
export default /*#__PURE__*/_defineComponent({
  props: {
    gameInfo: {
      type: Object,
      required: true
    }
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    const ipConfig = ref({
      defaultIpList: [],
      ipList: '',
      sw: 0
    });
    const getIpList = () => {
      apiUsdkGetTestAccountList({
        gid: props.gameInfo.Id
      }).then(res => {
        if (res.code === 0) {
          ipConfig.value = {
            defaultIpList: res.data.defaultIpList,
            ipList: res.data.ipList,
            sw: res.data.sw
          };
        }
      });
    };
    const handleConfirm = () => {
      const ipList = ipConfig.value.ipList && ipConfig.value.ipList.replace(/[\n\t\s，]/g, ',');
      const reg = /^(((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3},?)+$/;
      if (ipList && !reg.test(ipList)) {
        ElMessage({
          type: 'warning',
          message: '填写格式不合规，多个 ip 地址请使用英文符号‘,’进行分割，不要加入其他符号'
        });
        return;
      }
      let params = {
        gid: props.gameInfo.Id,
        ipList: ipList,
        sw: ipConfig.value.sw
      };
      apiUsdkCreateTestAccount(params).then(res => {
        if (res.code === 0) {
          getIpList();
        }
      });
    };
    onMounted(() => {
      getIpList();
    });
    expose({
      handleConfirm
    });
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      return _openBlock(), _createBlock(_component_u_card_pane, {
        name: "ipWhiteList"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_hoisted_1, _createVNode(USwitch, {
          modelValue: ipConfig.value.sw,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ipConfig.value.sw = $event),
          class: "marginL20"
        }, null, 8, ["modelValue"])]), ipConfig.value.defaultIpList && ipConfig.value.defaultIpList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ipConfig.value.defaultIpList, (item, index) => {
          return _openBlock(), _createElementBlock("span", {
            class: "ip-item",
            key: index
          }, [_createElementVNode("span", _hoisted_3, _toDisplayString(item.ip), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(item.remark), 1)]);
        }), 128))])) : _createCommentVNode("", true), _createVNode(_component_el_input, {
          modelValue: ipConfig.value.ipList,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ipConfig.value.ipList = $event),
          rows: 6,
          type: "textarea",
          placeholder: "请输入ip地址，以‘，’链接"
        }, null, 8, ["modelValue"])]),
        _: 1
      });
    };
  }
});